import camelCase from 'lodash/camelCase';
import { useEffect, useContext } from 'react';
import { useLocation, useHistory } from 'react-router-dom';

import { BrandContext } from 'context/BrandContext';
import { funnelSteps, dashboardRootPath, getRoutesMap, getBrandRoute } from 'helpers/routes';
import useFunnelMealPlan from 'hooks/useFunnelMealPlan';
import { FAMILY } from 'lib/constants';

import { UserContext } from './Contexts';

const FunnelUserWrapper = ({ children }) => {
  const location = useLocation();
  const history = useHistory();
  const { user } = useContext(UserContext);
  const { brand } = useContext(BrandContext);
  const mealPlanSlug = useFunnelMealPlan();
  const isFamilyMealPlan = mealPlanSlug === FAMILY;

  useEffect(() => {
    if (user && brand) {
      const routesMap = getRoutesMap(brand, isFamilyMealPlan);
      const routes = getBrandRoute({ brand, addSuffix: false });

      const funnelStepsPerBrand = funnelSteps({
        brand,
        isFamily: isFamilyMealPlan,
      });

      if (
        user.completedSignup &&
        !location.pathname.includes(routes.thankyou) &&
        !location.pathname.includes(routes.pickMealsThankYou)
      ) {
        window.location.replace(dashboardRootPath());
      } else if (
        routesMap[camelCase(user.status)] &&
        (funnelStepsPerBrand[location.pathname] === undefined ||
          funnelStepsPerBrand[location.pathname] >
            funnelStepsPerBrand[routesMap[camelCase(user.status)]])
      ) {
        history.replace(routesMap[user.status]);
      }
    }
  }, [user, history, brand, isFamilyMealPlan, location.pathname]);

  return children;
};

export default FunnelUserWrapper;
